<template>
    <div id="app">
        <router-view />
        <b-header></b-header>
        <b-footer></b-footer>
    </div>
</template>

<script>
import BHeader from '@/components/head'
import BFooter from '@/components/footer'
export default {
    name: 'app',
    components: { BHeader, BFooter },
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
.clear {
    clear: both;
}
canvas {
    display: block;
    position: absolute;
    width: 100%;
    height: 960px;
    top: 0;
    left: 0;
    background-image: linear-gradient(
        to right,
        rgb(1, 40, 63),
        rgb(0, 102, 161),
        rgb(1, 40, 63)
    );
}
</style>



// WEBPACK FOOTER //
// src/App.vue